const INSERT_TO_DB = '@@Database/INSERT_TO_DB';

export const insertToDb = (data) => {
    return {
        type: INSERT_TO_DB,
        payload: {data}
    };
};